/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import { AbChiclet } from "abreact/misc/AbChiclet";
import { AbIcon } from "abreact/misc/AbIcon";
import { AbButton } from "absdk/commons/ui/misc/AbButton";
import { AbSize } from "absdk/commons/ui/misc/AbSize";
import React from "react";

/**
 * An input that can be used in an Operand Value editor that expands a panel or opens a popup with
 * its actual controls. This shows a link and expander button, that expands/opens and collapses/closes,
 * and has styling showing the current state.
 */
export function ExpressionExpanderInput(props) {
  const {
    expanded,
    onExpand,
    onCollapse
  } = props;
  const onClick = React.useCallback(() => {
    if (expanded) {
      onCollapse();
    } else {
      onExpand();
    }
  }, [expanded, onExpand, onCollapse]);
  return /*#__PURE__*/React.createElement("div", {
    className: CssUtils.composeClassNames("guided-expression-editor-input", "guided-expression-expander-input")
  }, /*#__PURE__*/React.createElement(AbButton, {
    className: CssUtils.composeClassNames("guided-expression-expander-button", props.expanded && "expanded", props.primary && "primary"),
    dataTestId: props.dataTestId,
    size: AbSize.MEDIUM,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(AbChiclet, {
    className: "guided-expression-expander-chiclet",
    size: AbSize.EXTRA_SMALL,
    label: props.label,
    tooltip: props.tooltip
  }), /*#__PURE__*/React.createElement(AbIcon, {
    className: "guided-expression-expander-icon",
    image: props.expanded ? "absdk:collapse-caret" : "absdk:expand-caret",
    size: AbSize.EXTRA_SMALL
  })));
}
//# sourceMappingURL=ExpressionExpanderInput.js.map
